<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">currency_exchange</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Reporte de Conversiones USDT a CLP</h1>
  </div>

  <!-- Mensajes de error y éxito -->
  <div *ngIf="errorMessage" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div *ngIf="successMessage" class="success-snackbar mb-4">
    <mat-icon>check_circle</mat-icon>
    <span>{{ successMessage }}</span>
  </div>

  <!-- Resumen -->
  <div *ngIf="summary" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #3b82f6;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total Conversiones</h3>
      <p class="text-2xl font-bold text-gray-800 mt-1">{{ summary.totalConversions }}</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #8b5cf6;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total USDT Convertido</h3>
      <p class="text-2xl font-bold text-gray-800 mt-1">{{ formatUSDT(summary.totalUsdtConverted) }} USDT</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #16a34a;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Total CLP Generado</h3>
      <p class="text-2xl font-bold mt-1" style="color: #16a34a;">{{ formatCLP(summary.totalClpGenerated) }}</p>
    </div>
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 p-4 overflow-hidden"
      style="border-left: 4px solid #ea580c;">
      <h3 class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Tasa Promedio</h3>
      <p class="text-2xl font-bold mt-1" style="color: #ea580c;">{{ summary.averageRate }} CLP/USDT</p>
    </div>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario ID</mat-label>
            <input matInput formControlName="userId" placeholder="Ej: 12345" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Fin</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
          <button type="button" (click)="exportToExcel()" [disabled]="loading || conversions.length === 0"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading || conversions.length === 0 ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">download</mat-icon>
            Exportar Excel
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando datos...</span>
  </div>

  <!-- Card Tabla Conversiones -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading && conversions.length > 0">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
          Conversiones
        </h2>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-600">
            {{ (pagination.page - 1) * pagination.limit + 1 }} -
            {{ Math.min(pagination.page * pagination.limit, pagination.total) }}
            de {{ pagination.total }}
          </span>
          <select [value]="pagination.limit" (change)="onPageSizeChange($event)"
            style="border: 1px solid #d1d5db; border-radius: 6px; padding: 2px 8px; font-size: 0.75rem; background: white; cursor: pointer;">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tabla Desktop: hidden lg:block -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="conversions" class="w-full">
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>Usuario ID</th>
          <td mat-cell *matCellDef="let conversion"><span class="text-xs font-mono">{{ conversion.userId }}</span></td>
        </ng-container>

        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let conversion">
            <div class="text-xs font-medium">{{ conversion.userName }}</div>
            <div class="text-xs text-gray-400">{{ conversion.userEmail }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="usdtAmount">
          <th mat-header-cell *matHeaderCellDef>USDT</th>
          <td mat-cell *matCellDef="let conversion"><span class="text-xs font-bold">{{ formatUSDT(conversion.usdtAmount) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="clpRate">
          <th mat-header-cell *matHeaderCellDef>Tasa</th>
          <td mat-cell *matCellDef="let conversion"><span class="text-xs">{{ conversion.clpRate }}</span></td>
        </ng-container>

        <ng-container matColumnDef="clpTotal">
          <th mat-header-cell *matHeaderCellDef>CLP Total</th>
          <td mat-cell *matCellDef="let conversion"><span class="text-xs font-bold" style="color: #16a34a;">{{ formatCLP(conversion.clpTotal) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="conversionDate">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let conversion"><span class="text-xs text-gray-600">{{ formatDate(conversion.conversionDate) }}</span></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile: lg:hidden -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let conversion of conversions; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="text-xs font-mono text-gray-500 shrink-0">{{ conversion.userId }}</span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ conversion.userName }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold" style="color: #16a34a;">{{ formatCLP(conversion.clpTotal) }}</span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cliente</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ conversion.userName }}</p>
              <p class="text-gray-400 mt-0.5" style="font-size: 0.65rem;">{{ conversion.userEmail }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">USDT</span>
              <p class="text-gray-700 font-bold mt-0.5">{{ formatUSDT(conversion.usdtAmount) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tasa</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ conversion.clpRate }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">CLP Total</span>
              <p class="font-bold mt-0.5" style="color: #16a34a;">{{ formatCLP(conversion.clpTotal) }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatDate(conversion.conversionDate) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginaci&oacute;n -->
    <div class="p-4">
      <mat-paginator
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginatorChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <!-- Mensaje cuando no hay datos -->
  <div *ngIf="!loading && conversions.length === 0"
    class="bg-white rounded-2xl shadow-md border border-gray-100 text-center py-8">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">inbox</mat-icon>
    <p class="text-lg font-medium text-gray-500 mt-2">No se encontraron conversiones</p>
    <p class="text-sm text-gray-400">Intenta ajustar los filtros de b&uacute;squeda</p>
  </div>
</div>
